import { LearningAnswerType } from "../../learning/model/LearningAnswerType";
import styles from "../css/CorrectOrIncorrectTermsCount.module.css";
import { ReactComponent as CorrectIcon } from "../../../img/iconImgAllCorrect.svg";
import { ReactComponent as IncorrectIcon } from "../../../img/iconImgAllIncorrect.svg";
import { ReactComponent as NoRecordIcon } from "../../../img/iconImgAllNoRecord.svg";
import { toDecimalString } from "../strings";

interface CorrectOrIncorrectTermsCountViewProps {
  showing: boolean;
  type?: LearningAnswerType;
  termsCount: number;
}

export default function CorrectOrIncorrectTermsCountView(
  props: CorrectOrIncorrectTermsCountViewProps
) {
  if (!props.showing) return null;

  return (
    <>
      <div className={styles.container}>
        {props.type === undefined && (
          <NoRecordIcon
            style={{
              color: "var(--button-disabled-text-color)",
            }}
          />
        )}

        {props.type === undefined && (
          <span className={styles.noRecordTermCountText}>
            {toDecimalString(props.termsCount)}
          </span>
        )}

        {props.type === LearningAnswerType.correct && (
          <CorrectIcon
            style={{
              color: "var(--level-three-color)",
            }}
          />
        )}
        {props.type === LearningAnswerType.correct && (
          <span className={styles.correctTermCountText}>
            {toDecimalString(props.termsCount)}
          </span>
        )}
        {props.type === LearningAnswerType.incorrect && (
          <IncorrectIcon
            style={{
              color: "var(--level-one-color)",
            }}
          />
        )}
        {props.type === LearningAnswerType.incorrect && (
          <span className={styles.incorrectTermCountText}>
            {toDecimalString(props.termsCount)}
          </span>
        )}
      </div>
    </>
  );
}
